import axiosInstance from "../../api/axios";

export const getThemeAxis = async () => {
  try {
    const { data } = await axiosInstance.get(`/examsimulator/thematicaxes`);

    return data;
  } catch(e: any) {
    throw new Error(e)
  }
}